const middleware = {}

middleware['auth'] = require('../../25/middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['btag'] = require('../../25/middleware/btag.js')
middleware['btag'] = middleware['btag'].default || middleware['btag']

middleware['i18n'] = require('../../25/middleware/i18n.js')
middleware['i18n'] = middleware['i18n'].default || middleware['i18n']

middleware['page-load'] = require('../../25/middleware/page-load.js')
middleware['page-load'] = middleware['page-load'].default || middleware['page-load']

middleware['remove-duplicate-query-params'] = require('../../25/middleware/remove-duplicate-query-params.js')
middleware['remove-duplicate-query-params'] = middleware['remove-duplicate-query-params'].default || middleware['remove-duplicate-query-params']

middleware['title'] = require('../../25/middleware/title.js')
middleware['title'] = middleware['title'].default || middleware['title']

middleware['userTip'] = require('../../25/middleware/userTip.js')
middleware['userTip'] = middleware['userTip'].default || middleware['userTip']

export default middleware
